import AbstractModel, { Model } from './abstract-model';

@Model('CavSourcesInfo')
export default class CavSourcesInfo extends AbstractModel {
    public numSeq: number = null;
		public cavCavite: string = null;
		public sourceInformation: string = null;
		public lieuArchivage: string = null;
}

